import type { AdItem, BloomRuntimeConfig, ClientType } from '@apm/contracts';
import { buildAdHandoffRequest, requestPurchaseHandoff } from './bloom-handoff.js';
import { config } from './config.js';
import { handoffFromError, handoffFromResponse, sheetForAd } from './handoff.js';
import type { AdSheetTarget, HandoffState } from './handoff.js';

/**
 * **광고 구매 한 번** — 개인화 채널(`WatchScreen`)과 ONAIR CSPM(`OnairScreen`)이 같이 부른다 (v38 · `docs/77` §5.5).
 *
 * 꺼내기 전에는 `WatchScreen.requestAdHandoff` 안에 있었다 — 그대로 옮겼다(동작 변화 0). 두 화면이 각자 쓰면 한쪽만 고쳐진다.
 *
 * ★ **누른 순간의 광고를 붙든다** (v21/F13) — 왕복 동안 광고가 넘어갈 수 있고, 시청자가 보려는 것은 누를 때 보던 그
 * 광고다. 그래서 `ad` 를 받아 그 값으로 시트를 연다. **`purchase_click` 을 내지 않는다** — 그것은 회차에 귀속되는
 * `EVENT_TYPES` 의 값이다(절대 규칙 50·55). 광고 쪽 클릭은 VAST 트래킹이 맡는다.
 */
export async function runAdHandoff(input: {
  runtime: BloomRuntimeConfig;
  clientType: ClientType;
  ad: AdItem;
  /** 광고 중에도 재생 맥락은 그 회차다 — ONAIR 는 `null`(회차를 모른다) */
  contentProductId: string | null;
  channelId: string;
  playlistId: string | null;
  receiverDeviceId: string;
  senderDeviceId: string | null;
  token: string | null;
}): Promise<HandoffState> {
  const adTarget: AdSheetTarget = { productId: input.ad.creativeId, campaignId: input.ad.creativeId };
  try {
    const response = await requestPurchaseHandoff(
      input.runtime,
      buildAdHandoffRequest({
        clientType: input.clientType,
        ad: input.ad,
        contentProductId: input.contentProductId,
        channelId: input.channelId,
        playlistId: input.playlistId,
        receiverDeviceId: input.receiverDeviceId,
        senderDeviceId: input.senderDeviceId,
      }),
      { bloomServerUrl: config.serverUrl, token: input.token },
    );
    return sheetForAd(handoffFromResponse(response), adTarget);
  } catch (error) {
    return handoffFromError(error);
  }
}
